export default __webpack_public_path__ + "static/media/hango-screenshot-06.9d277054.png";